import { createUseStyles } from 'react-jss';

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 0 5rem',
  },
  logo: {
    borderRadius: '0.3rem',
    // Make logo with dynamic width but with max value
    height: 'auto',
    width: '50%',
    maxWidth: '24.7rem',
  },
  dropdownButton: {
    fontWeight: 700,
    height: '3.5rem',
    padding: '0px 1rem',
    fontSize: '1.6rem',
    lineHeight: '2.6rem',
  },
  dropdownOpenedBtn: {
    border: '2px solid transparent',
  },
  dropdownOption: { padding: '1.6rem' },
};

const createStyles = createUseStyles(styles);
export { createStyles };
